var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFacebook01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 9 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.23 9.26.456-2.977H5.831v-1.93a1.488 1.488 0 0 1 1.678-1.609h1.3V.21c-.76-.122-1.53-.189-2.3-.2a3.633 3.633 0 0 0-3.888 4.005v2.268H0V9.26h2.614v7.194c1.066.167 2.151.167 3.217 0V9.26z"
})));
export default SvgIconFacebook01;